
function NavProgram() {

    this.build();
    barbaCallbacks.push(this);

}

NavProgram.prototype.build = function(){

    $('.program-mozaic-navigation a').on('click', function(e){
        let element = $($(this).attr('href'));
        e.preventDefault();
        window.scrollTo({
            top: element.offset().top,
            left: 0,
            behavior: 'smooth'
        });
    });

    let hash = location.hash;

    if( hash !== "" ){
        $('.program-mozaic-navigation a[href="'+hash+'"]').trigger('click');
    }

};
